// @ts-check
import { enums } from '@bluecrew/bluecrew-lib'
import { Category } from '../constants'

export class absentModalController {
  /* @ngInject */
  constructor (roster, $mdDialog, PayrollService, $mdToast, $window) {
    this.PayrollService = PayrollService
    this.$mdToast = $mdToast
    this.roster = roster
    this.$mdDialog = $mdDialog
    this.$window = $window;
    this.enums = enums
    this.dsb = false

    /** @type {?import('../types').ExcuseReason} */ 
    this.absentReason = null // Managed by an md-select in absent-modal.html

    /** @type {?boolean} */
    this.informedInAdvance = null

    // We should probably just add the first name as a thing that is passed in the roster object
    this.cmFirstName = this.roster.fullname.split(' ')[0]
    
    this.statusChangeReasonsInformedInAdvance = [
      { value: 26, description: 'No reason given by CM', type: this.enums.PayrollHoursStatus.EXCUSED},
      { value: 18, description: 'Transportation issue', type: this.enums.PayrollHoursStatus.EXCUSED},
      { value: 17, description: 'Illness, medical issue, or injury', type: this.enums.PayrollHoursStatus.EXCUSED},
      { value: 14, description: 'Family emergency', type: this.enums.PayrollHoursStatus.EXCUSED},
      { value: 27, description: 'Vacation', type: this.enums.PayrollHoursStatus.EXCUSED},
      { value: 7, description: 'Resigned', type: this.enums.PayrollHoursStatus.EXCUSED},
    ]

    this.statusChangeReasonsNotInformedInAdvance = [
      { value: 8, description: 'No CM communication', type: this.enums.PayrollHoursStatus.REJECTED},
      { value: 8, description: 'No reason given by CM', type: this.enums.PayrollHoursStatus.REJECTED},
      { value: 9, description: 'Resigned', type: this.enums.PayrollHoursStatus.REJECTED},
      { value: 28, description: 'Transportation issue', type: this.enums.PayrollHoursStatus.REJECTED},
      { value: 29, description: 'Illness, medical issue, or injury', type: this.enums.PayrollHoursStatus.EXCUSED},
      { value: 30, description: 'Family emergency', type: this.enums.PayrollHoursStatus.EXCUSED},
      { value: 31, description: 'Vacation', type: this.enums.PayrollHoursStatus.REJECTED},
    ]
    
    // This array is what the md-select reads to show values
    // It is is given values once a user selects YES/NO if they were informed in advance by the CM
    this.statusChangeReasons = []
  }

  cancel () {
    this.$mdDialog.cancel()
  }

  toggleCheckbox () {
    this.dsb = !this.dsb
  }

  /**
   * Set the 'informedInAdvance' boolean flag
   * @param {boolean} informedInAdvance
   */
  setInformedByCMInAdvance (informedInAdvance) {
    // Reset selected reason, if any, when user switches between YES/NO
    this.absentReason = null
    this.informedInAdvance = informedInAdvance
    if (this.informedInAdvance) {
      this.statusChangeReasons = this.statusChangeReasonsInformedInAdvance
    }
    else if (!this.informedInAdvance) {
      this.statusChangeReasons = this.statusChangeReasonsNotInformedInAdvance
    }
  }

  /**
   * Submit an absence
   * @param {boolean} dsb 
   */
  submitAbsence (dsb) {
    const comments = undefined
    const category = Category.MarkedAbsent
    const reason = this.absentReason?.value
    const userHoursStatus = this.absentReason?.type

    // Absent reason is set by selecting an item from the select box,
    // the button that triggers this function is disabled until a value is selected, 
    // thus absentReason should never be null, so this error message should never pop.
    if (this.absentReason == null) {
      this.$mdToast.err("Absent reason cannot be null")
      return 
    }

    this.PayrollService
      .updateHoursStatus(userHoursStatus, this.roster.external_id, this.roster.job.external_id, this.roster.shift, reason, comments)
      .then(res => {
        this.roster.hours_id = res.data
        this.$mdDialog.hide({roster: this.roster, category, usersHoursReasonCode: reason, dsb})
        // No window reloading because the reload will kill the DSB modal that pops after,
        // if 'Yes, cancel remaining shifts and do not send back' is selected
      })
      .catch(err => {
        this.$mdToast.showSimple(err)
      })
  }
}
